import type {
  AnalyticsEvent,
  AnalyticsEventParamsOf,
} from "@v2/features/infra/analytics/events";

import * as React from "react";

import { toast } from "@replo/design-system/components/toast/Toast";
import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";

type ErrorEventType = Extract<AnalyticsEvent["type"], `error.${string}`>;

export const useErrorToast = () => {
  const logEvent = useLogAnalytics();

  return React.useCallback(
    (
      title: string,
      message: string,
      eventName: ErrorEventType,
      params?: AnalyticsEventParamsOf<ErrorEventType>,
    ) => {
      logEvent(eventName, params);
      return toast.error({ title, description: message });
    },
    [logEvent],
  );
};
